import React from 'react'
import { ScrollingTexts } from '../../../../enums/page_texts/homepage_texts'
import { ScrollingTextContainer, Row } from '../../../../styles/Homepage/ScrollingTexts.style'
import { MobileScrollText } from '../../../../styles/MOBILE/MobileStyles'
import AvailableViews from '../../../../enums/views'

const MobileScrollingTextPrivate: React.FC = () => {
    return (
        <ScrollingTextContainer>
            <Row>
                <MobileScrollText variant="h4" direction="left">
                    <a href={AvailableViews.PrivateEvents} style={{ all: 'unset' }}>
                        {ScrollingTexts.Row1Text1} · {ScrollingTexts.Row1Text2} · {ScrollingTexts.Row1Text3}
                    </a>
                </MobileScrollText>
            </Row>
        </ScrollingTextContainer>
    )
}

export default MobileScrollingTextPrivate


